import { render, staticRenderFns } from "./plansCard.vue?vue&type=template&id=c80a0d54"
import script from "./plansCard.vue?vue&type=script&lang=js"
export * from "./plansCard.vue?vue&type=script&lang=js"
import style0 from "./plansCard.vue?vue&type=style&index=0&id=c80a0d54&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports